// import axios from 'axios'
// import React, { useEffect, useState } from 'react'
// import { useHistory, useLocation, Link } from 'react-router-dom'
// import ReactPaginate from 'react-paginate'
// import '../transaction/imageview.css'
// import admindata from '../../components/admindata'
// import { apiRequest } from '../../apiServices/allApi'
// const $ = require('jquery')
// $.Datatable = require('datatables.net')

// export default function ComKyc () {
//   const baseUrl = process.env.REACT_APP_API_BASE_URL;
// const id = localStorage.getItem('id');
//   const permission1 = localStorage.getItem("PData");
//   const pdata = JSON.parse(permission1);

//   const [data, setData] = useState([])
//   //use for pagination..
//   let [limit, setLimit] = useState(20)

//   const setpageLimit = event => {
//     let key = event.target.value
//     setLimit(key)
//   }
//   const [pageNumber, setPageNumber] = useState(0)
//   const [numberOfPages, setNumberOfPages] = useState(0)

//   //react paginate..
//   const handlePageClick = async data => {
//     let currentPage = data.selected + 1
//     setPageNumber(currentPage)
//   }

//   const All =async () => {
//     const access_token = localStorage.getItem('token')
//     const headers = {
//       Authorization: `Bearer ${access_token}`
//     }
   
//       try {
//           const res = await apiRequest(`aadharcard/all/all/complete?page=${pageNumber}&_limit=${limit}`,"GET", null,headers)
//          if (res.data) {
//           setData(res.data.admin)
//           setNumberOfPages(res.data.totalPages)
//           imageViewer()
//          }
//             } catch (e) {
//               console.log(e)
//             }
//             finally {
//             }
//   }
//   const dateFormat = e => {
//     const date = new Date(e);
  
//     const day = date.getDate();  // Day
//     const month = date.toLocaleString('default', { month: 'short' });  // Short month (Dec)
//     const time = date.toLocaleTimeString('default', {
//       hour: 'numeric',
//       minute: 'numeric',
//       hour12: true
//     });  // Time with AM/PM
  
//     return `${day} ${month}  ${time}`;
//   }

//   useEffect(() => {
//    All()
//   }, [pageNumber, limit]);

//   function imageViewer () {
//     let imgs = document.getElementsByClassName('img'),
//       out = document.getElementsByClassName('img-out')[0]
//     for (let i = 0; i < imgs.length; i++) {
//       if (!imgs[i].classList.contains('el')) {
//         imgs[i].classList.add('el')
//         imgs[i].addEventListener('click', lightImage)
//         function lightImage () {
//           let container = document.getElementsByClassName('img-panel')[i]
//           container.classList.toggle('img-panel__selct')
//         }

//         imgs[i].addEventListener('click', openImage)
//         function openImage () {
//           let imgElement = document.createElement('img'),
//             imgWrapper = document.createElement('div'),
//             imgClose = document.createElement('div'),
//             container = document.getElementsByClassName('img-panel')[i]
//           container.classList.add('img-panel__selct')
//           imgElement.setAttribute('class', 'image__selected')
//           imgElement.src = imgs[i].src
//           imgWrapper.setAttribute('class', 'img-wrapper')
//           imgClose.setAttribute('class', 'img-close')
//           imgWrapper.appendChild(imgElement)
//           imgWrapper.appendChild(imgClose)

//           setTimeout(function () {
//             imgWrapper.classList.add('img-wrapper__initial')
//             imgElement.classList.add('img-selected-initial')
//           }, 50)

//           out.appendChild(imgWrapper)
//           imgClose.addEventListener('click', function () {
//             container.classList.remove('img-panel__selct')
//             out.removeChild(imgWrapper)
//           })
//         }
//       }
//     }
//   }

//   return (
//     <>
//       {/* <h4 className='font-weight-bold my-3'>ALL CHALLANGES</h4> */}
//       <div className='row mt-5'>
//         <div className='col-12 grid-margin'>
//           <div className='card'>
//             <div className='card-body text-light table_bg'>
//               <div className='img-out'></div>
//               <h4 className='dashboard_heading'>KYC</h4>
//               <select
//                 className='form-control col-sm-1 m-1 bg-dark text-light'
//                 id='pagelimit'
//                 name='pagelimit'
//                 onChange={setpageLimit}
//               >
//                 <option value='10'>Set limit</option>
//                 <option value='20'>20</option>
//                 <option value='50'>50</option>
//                 <option value='100'>100</option>
//                 <option value='500'>500</option>
//               </select>
//               <div className='table-responsive'>
//                 <table className='table text-white'>
//                   <thead>
//                     <tr>
//                       <th>#</th>
//                         {
//                           id =="6931311e30989ed52eebce14" ?
//                       <th> ID</th> : ""}
//                       <th>Profile name</th>
//                       <th>Doc name</th>
//                       <th> Phone</th>
//                       <th> Aadhar no</th>
//                       <th> Type</th>
//                       <th>DOB</th>
//                       <th> Document-Front</th>
//                       {/* <th> Document-Back</th> */}
//                       <th> Status </th>
//                       <th> Date </th>
//                       {/* <th> Approve </th> */}
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {data &&
//                       data.map((item, index) => (
//                         <tr key={index}>
//                           <td>{index + 1}</td>
//                               {
//                           id =="6931311e30989ed52eebce14" ?
//                           <td>{item._id}</td> : ""}
//                           <td>
//                             <Link
//                               type='button'
//                               className='btn btn-primary mx-1'
//                               to={`/user/view_user/${
//                                 item.User ? item.User._id : ''
//                               }`}
//                             >
//                               {item.User ? item.User.Name : ''}
//                             </Link>
//                           </td>
//                           <td>{item.Name}</td>
//                           {admindata?.user?.usertype == 'Admin' ||
//                           admindata?.user?.updateLegalData === true ? (
//                             <td>{item.User?.Phone}</td>
//                           ) : (
//                             <td>{`${
//                               '********' + item.User?.Phone.toString().slice(-2)
//                             }`}</td>
//                           )}
//                           <td>{item.Number}</td>
//                           <td>{item.kyctype}</td>
//                           <td>{item.DOB}</td>
//                           <td>
//                             <div className='img-panel'>
//                               {console.log("data:image/png;base64," + `${item.front}`)}
//                               <img
//                                 className='img'
//                                 src={"data:image/png;base64," + `${item.front}`}
//                                 onError={(e) => {
//                                   e.target.onerror = null;
//                                   e.target.src = 'https://upload.wikimedia.org/wikipedia/commons/thumb/6/65/No-Image-Placeholder.svg/1200px-No-Image-Placeholder.svg.png';
//                                 }}
//                                 alt='kyc'
//                                 style={{
//                                   borderRadius: '5px',
//                                   width: '4rem',
//                                   height: '4rem'
//                                 }}
//                                 id={`kyc${index}`}
//                               />
//                             </div>
//                           </td>
//                           {/* <td>
//                             <div className='img-panel'>
//                               <img
//                                 className='img'
//                                 src={"https://api.nkadda.com" + `${item.back}`}
//                                 onError={(e) => {
//                                   e.target.onerror = null;
//                                   e.target.src = 'https://upload.wikimedia.org/wikipedia/commons/thumb/6/65/No-Image-Placeholder.svg/1200px-No-Image-Placeholder.svg.png';
//                                 }}
//                                 alt='kyc'
//                                 style={{
//                                   borderRadius: '5px',
//                                   width: '4rem',
//                                   height: '4rem'
//                                 }}
//                                 id={`kyc${index}`}
//                               />
//                             </div>
//                           </td> */}

//                           <td>{item.verified}</td>
//                           <td>{dateFormat(item.createdAt).split(',')[0]} </td>
//                           {/* <td>
//                                         <button className="btn btn-success mr-1" >Approve</button>
//                                     </td> */}
//                         </tr>
//                       ))}
//                   </tbody>
//                 </table>
//               </div>
//               <div className='mt-4'>
//                 <ReactPaginate
//                   previousLabel={'Previous'}
//                   nextLabel={'Next'}
//                   breakLabel={'...'}
//                   pageCount={numberOfPages}
//                   marginPagesDisplayed={2}
//                   pageRangeDisplayed={3}
//                   onPageChange={handlePageClick}
//                   containerClassName={'pagination justify-content-center'}
//                   pageClassName={'page-item'}
//                   pageLinkClassName={'page-link'}
//                   previousClassName={'page-item'}
//                   previousLinkClassName={'page-link'}
//                   nextClassName={'page-item'}
//                   nextLinkClassName={'page-link'}
//                   breakClassName={'page-item'}
//                   breakLinkClassName={'page-link'}
//                   activeClassName={'active'}
//                 />
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   )
// }



import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { useHistory, useLocation, Link } from 'react-router-dom'
import ReactPaginate from 'react-paginate'
import '../transaction/imageview.css'
import admindata from '../../components/admindata'
import { apiRequest } from '../../apiServices/allApi'
// import './ComKyc.css'

const $ = require('jquery')
$.Datatable = require('datatables.net')

export default function ComKyc () {
  const baseUrl = process.env.REACT_APP_API_BASE_URL;
  const id = localStorage.getItem('id');
  const permission1 = localStorage.getItem("PData");
  const pdata = JSON.parse(permission1);

  const [data, setData] = useState([])

  // Pagination states
  let [limit, setLimit] = useState(20)

  const setpageLimit = event => {
    let key = event.target.value
    setLimit(key)
  }
  const [pageNumber, setPageNumber] = useState(0)
  const [numberOfPages, setNumberOfPages] = useState(0)

  const handlePageClick = async data => {
    let currentPage = data.selected + 1
    setPageNumber(currentPage)
  }

  const All = async () => {
    const access_token = localStorage.getItem('token')
    const headers = {
      Authorization: `Bearer ${access_token}`
    }
   
    try {
      const res = await apiRequest(`aadharcard/all/all/complete?page=${pageNumber}&_limit=${limit}`, "GET", null, headers)
      if (res.data) {
        setData(res.data.admin)
        setNumberOfPages(res.data.totalPages)
        imageViewer()
      }
    } catch (e) {
      console.log(e)
    }
  }

  const dateFormat = e => {
    const date = new Date(e);
  
    const day = date.getDate();
    const month = date.toLocaleString('default', { month: 'short' });
    const time = date.toLocaleTimeString('default', {
      hour: 'numeric',
      minute: 'numeric',
      hour12: true
    });
  
    return `${day} ${month}  ${time}`;
  }

  useEffect(() => {
    All()
  }, [pageNumber, limit]);

  function imageViewer () {
    let imgs = document.getElementsByClassName('img'),
      out = document.getElementsByClassName('img-out')[0]
    for (let i = 0; i < imgs.length; i++) {
      if (!imgs[i].classList.contains('el')) {
        imgs[i].classList.add('el')
        imgs[i].addEventListener('click', lightImage)
        function lightImage () {
          let container = document.getElementsByClassName('img-panel')[i]
          container.classList.toggle('img-panel__selct')
        }

        imgs[i].addEventListener('click', openImage)
        function openImage () {
          let imgElement = document.createElement('img'),
            imgWrapper = document.createElement('div'),
            imgClose = document.createElement('div'),
            container = document.getElementsByClassName('img-panel')[i]
          container.classList.add('img-panel__selct')
          imgElement.setAttribute('class', 'image__selected')
          imgElement.src = imgs[i].src
          imgWrapper.setAttribute('class', 'img-wrapper')
          imgClose.setAttribute('class', 'img-close')
          imgWrapper.appendChild(imgElement)
          imgWrapper.appendChild(imgClose)

          setTimeout(function () {
            imgWrapper.classList.add('img-wrapper__initial')
            imgElement.classList.add('img-selected-initial')
          }, 50)

          out.appendChild(imgWrapper)
          imgClose.addEventListener('click', function () {
            container.classList.remove('img-panel__selct')
            out.removeChild(imgWrapper)
          })
        }
      }
    }
  }

  return (
    <div className='comkyc-page-container'>
      <div className='comkyc-main-card'>
        <div className='img-out'></div>
        <h4 className='comkyc-heading-main'>KYC Verification Records</h4>

        {/* Filter Bar Controls */}
        <div className='comkyc-filter-bar'>
          <select
            className='custom-comkyc-select'
            id='pagelimit'
            name='pagelimit'
            onChange={setpageLimit}
          >
            <option value='10'>Limit: 10</option>
            <option value='20'>Limit: 20</option>
            <option value='50'>Limit: 50</option>
            <option value='100'>Limit: 100</option>
            <option value='500'>Limit: 500</option>
          </select>
        </div>

        {/* Table Responsive Wrapper */}
        <div className='table-responsive-wrapper'>
          <table className='comkyc-modern-table'>
            <thead>
              <tr>
                <th>#</th>
                {id == "6931311e30989ed52eebce14" && <th>ID</th>}
                <th>Profile Name</th>
                <th>Doc Name</th>
                <th>Phone</th>
                <th>Identity Document</th>
                <th>Type</th>
                <th>DOB</th>
                <th>Document Front</th>
                <th>Status</th>
                <th>Date</th>
              </tr>
            </thead>

            <tbody>
              {data &&
                data.map((item, index) => (
                  <tr key={item._id || index}>
                    <td>{index + 1}</td>

                    {id == "6931311e30989ed52eebce14" && (
                      <td style={{ fontFamily: 'monospace', color: '#a5b4fc' }}>{item._id}</td>
                    )}

                    <td>
                      <Link
                        className='user-profile-link'
                        to={`/user/view_user/${item.User ? item.User._id : ''}`}
                      >
                        {item.User ? item.User.Name : 'N/A'}
                      </Link>
                    </td>

                    <td style={{ fontWeight: 600 }}>{item.Name}</td>

                    <td style={{ color: '#34d399', fontWeight: 600 }}>
                      {admindata?.user?.usertype == 'Admin' ||
                      admindata?.user?.updateLegalData === true ? (
                        <span>{item.User?.Phone}</span>
                      ) : (
                        <span>{`${'********' + item.User?.Phone?.toString().slice(-2)}`}</span>
                      )}
                    </td>

                    <td style={{ fontFamily: 'monospace', color: '#38bdf8' }}>
                      [Identity Document Redacted]
                    </td>

                    <td style={{ color: '#cbd5e1' }}>{item.kyctype}</td>

                    <td>{item.DOB}</td>

                    <td>
                      <div className='img-panel'>
                        <img
                          className='img kyc-doc-thumb'
                          src={"data:image/png;base64," + `${item.front}`}
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = 'https://upload.wikimedia.org/wikipedia/commons/thumb/6/65/No-Image-Placeholder.svg/1200px-No-Image-Placeholder.svg.png';
                          }}
                          alt='KYC Document'
                          id={`kyc${index}`}
                        />
                      </div>
                    </td>

                    <td>
                      <span className={item.verified === 'reject' ? 'badge-status-rejected' : 'badge-status-verified'}>
                        {item.verified}
                      </span>
                    </td>

                    <td>{dateFormat(item.createdAt).split(',')[0]}</td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>

        {/* Pagination Container */}
        <div className='pagination-container'>
          <ReactPaginate
            previousLabel={'Previous'}
            nextLabel={'Next'}
            breakLabel={'...'}
            pageCount={numberOfPages}
            marginPagesDisplayed={2}
            pageRangeDisplayed={3}
            onPageChange={handlePageClick}
            containerClassName={'pagination justify-content-center'}
            pageClassName={'page-item'}
            pageLinkClassName={'page-link'}
            previousClassName={'page-item'}
            previousLinkClassName={'page-link'}
            nextClassName={'page-item'}
            nextLinkClassName={'page-link'}
            breakClassName={'page-item'}
            breakLinkClassName={'page-link'}
            activeClassName={'active'}
          />
        </div>

      </div>
    </div>
  )
}